import type { TableSortState } from '../UI';

// Keeps every column readable before the table starts scrolling horizontally.
export const INTERVENTIONS_TABLE_MIN_WIDTH = 960;

// The name column's sort key, shared because the default sort below has to
// point at the same column `getInterventionColumns` renders; a mismatch orders
// nothing, and only Table's own warning would say so.
export const INTERVENTION_NAME_COLUMN_KEY = 'name';

// The duration column's sort key. Durations are plain minutes, so the
// comparator comes out numeric rather than lexicographic on its own.
export const INTERVENTION_DURATION_COLUMN_KEY = 'duration';

// The catalogue opens ordered by name instead of in whatever order the backend
// returned it. Gigtforeningen's list is expected to outgrow a screen, and
// finding a named intervention is what nearly every visit here is for
// (REH-344). The alphabet itself is Danish for every user, pinned in the
// table's comparator rather than here.
export const DEFAULT_INTERVENTIONS_SORT: TableSortState = {
  key: INTERVENTION_NAME_COLUMN_KEY,
  direction: 'asc'
};

// The room requirement whose tag renders in the "online" colour. This is matched
// against a backend-supplied display name, so renaming the room in the admin UI
// silently drops the styling. Keying off a room flag would be sturdier if the
// API ever exposes one.
export const ONLINE_ROOM_NAME = 'Online';

// One menu trigger rather than the two icon buttons that used to sit here, so the
// column needs only enough room for the trigger and its focus ring.
export const ACTIONS_COLUMN_WIDTH = 64;

// The backend answers a create that references an archived staff competence with 409
// Conflict (ArchivedStaffProfessionReferencedException). Duplicating is the one flow that
// can hit it without the user having touched the requirements, so it is named here rather
// than compared inline.
export const ARCHIVED_COMPETENCE_CONFLICT_STATUS = 409;
